import './App.css';
import './style/css/reset.css'
import './style/css/sidebar.css'
import './style/css/style.css'
import './style/css/zone.css'
import { Routes, Route, Navigate } from 'react-router-dom'
import Login from './Pages/Login';
import { ProtectedRoute } from './Components/ProtectedRoute';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import OurSportsStream from './Pages/OurSportsStream';
import EltaRawData from './Pages/EltaRawData';
export const OpenindDayDate = new Date(2022, 3, 3)

const App = () => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <div className="App">
        <Routes>
          <Route path='/oursport' element={<ProtectedRoute element={<OurSportsStream />} />} />
          <Route path='/elta-raw-data' element={<ProtectedRoute element={<EltaRawData />} />} />
          <Route path='/login' element={<Login />} />
          <Route path='*' element={<Navigate to='/login' replace />} />

        </Routes>
      </div>
    </LocalizationProvider>
  );
}

export default App;
